import { render, staticRenderFns } from "./modal_newstrend_post.vue?vue&type=template&id=2285597c&scoped=true&"
import script from "./modal_newstrend_post.vue?vue&type=script&lang=js&"
export * from "./modal_newstrend_post.vue?vue&type=script&lang=js&"
import style0 from "./modal_newstrend_post.vue?vue&type=style&index=0&id=2285597c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285597c",
  null
  
)

export default component.exports